/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderBoardCertificationList } from '../models/PaginatedProviderBoardCertificationList';
import type { PatchedProviderBoardCertificationWrite } from '../models/PatchedProviderBoardCertificationWrite';
import type { ProviderBoardCertification } from '../models/ProviderBoardCertification';
import type { ProviderBoardCertificationWrite } from '../models/ProviderBoardCertificationWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderBoardCertificationsService {

    /**
     * @returns PaginatedProviderBoardCertificationList
     * @throws ApiError
     */
    public static providerBoardCertificationsList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderBoardCertificationList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-board-certifications/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderBoardCertification
     * @throws ApiError
     */
    public static providerBoardCertificationsCreate({
        requestBody,
    }: {
        requestBody: ProviderBoardCertificationWrite,
    }): CancelablePromise<ProviderBoardCertification> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-board-certifications/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderBoardCertification
     * @throws ApiError
     */
    public static providerBoardCertificationsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this board certification.
         */
        id: string,
    }): CancelablePromise<ProviderBoardCertification> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-board-certifications/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderBoardCertification
     * @throws ApiError
     */
    public static providerBoardCertificationsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this board certification.
         */
        id: string,
        requestBody?: PatchedProviderBoardCertificationWrite,
    }): CancelablePromise<ProviderBoardCertification> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-board-certifications/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static providerBoardCertificationsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this board certification.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-board-certifications/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
